var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"pay-online-modal","size":"md"}},[_c('div',{staticClass:"row text-white content text-left"},[_c('pay-online-form',{attrs:{"pay-for-id":_vm.payForId,"type-id":_vm.typeId,"price":_vm.price,"auto-redirect":_vm.autoRedirect}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }